import type { ArchivoRecord } from '@/otros-tramites/types';
import WhatsAppEventModal from './WhatsAppEventModal';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tramite: any;
  archivo: ArchivoRecord;
};

const WhatsAppOtroTramiteFacturaModal = ({
  open,
  onOpenChange,
  tramite,
  archivo,
}: Props) => {
  return (
    <WhatsAppEventModal
      open={open}
      onOpenChange={onOpenChange}
      tramite={tramite}
      eventType="otros_tramites.envio_factura"
      title="Enviar factura por WhatsApp"
      description="Se enviará la factura con enlace temporal seguro."
      contextOverrides={{
        otro_tramite_id: tramite.id,
        tramite_id: tramite.id,
        archivo_id: archivo.id,
      }}
    />
  );
};

export default WhatsAppOtroTramiteFacturaModal;
